import React from "react";
import "../Css/wa.css";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5491124856291"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-container"
    >
      <div className="whatsapp-card">
        <div className="whatsapp-chat">
          <span className="whatsapp-text">Agendános...</span>
          <img src="/Logos/send.png" alt="Enviar" loading="lazy"/>
        </div>
      </div>
      <div className="whatsapp-button">
        <img src={"/Logos/wa.svg"} alt="WhatsApp" loading="lazy" />
      </div>
    </a>

  );
};

export default WhatsAppButton;
